import template from './order-shipments.html';
export var OrderShipmentsComponent = {
    template: template,
    bindings: {
        shipments: '<',
        orderOrigin: '<'
    },
    controller: /** @class */ (function () {
        /*@ngInject*/
        function OrderShipmentsComponent(CartService, Auth, $state) {
            var _this = this;
            this.$state = $state;
            this.CartService = CartService;
            Auth.isLoggedIn(function (user) {
                _this.storeFrontId = user.storefrontId;
                _this.isImpersonated = user.isImpersonated;
            });
        }
        OrderShipmentsComponent.prototype.createCartAndAddItems = function (shipment) {
            var _this = this;
            this.CartService.createInactiveCart(this.storeFrontId).then(function () {
                var itemList = shipment.lineItems.map(function (item) { return ({ itemId: item.itemId, quantity: item.quantityOrdered }); });
                _this.CartService.addItems(itemList).then(function () { return _this.$state.go('cart'); });
            });
        };
        return OrderShipmentsComponent;
    }())
};
//# sourceMappingURL=order-shipments.component.js.map